export const MODIFY_MODAL_INFO = 'MODIFY_MODAL_INFO';

export function modifyModalInfo(modalInfo){
    return{
        type: MODIFY_MODAL_INFO,
        mainState: {
            modalInfo: modalInfo
        }
    }
}